import React, { useEffect, useState, useRef } from 'react';
import { useStyles } from './Style';
import { Typography, Grid } from '@mui/material';
import { InputV2, ButtonLoading, LoadingPage, CustomCaptchaComponent } from 'components';
import { useForm, FormProvider } from 'react-hook-form';
import { AuthService } from 'components/Auth';
import { useUserDispatcher } from 'hooks';
import ChangePasswordServices from './services/ChangePasswordServices';
import createToast from 'components/Toast/Toast';

const ChangePassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [enteredCaptcha, setEnteredCaptcha] = useState('');
  const [captchaId, setCaptchaId] = useState(null);

  // -- HOOKS --//
  const classes = useStyles();

  const methods = useForm();
  const { handleSubmit, reset } = methods;

  const captchaRef = useRef();
  const setUser = useUserDispatcher();

  useEffect(() => {
    methods.setValue('captchaAnswer', enteredCaptcha);
  }, [enteredCaptcha]);
  const changePass = async (data) => {
    if (data?.newPassword !== data?.newPassword2) {
      createToast('خطا', 'رمز عبور جدید و تکرار آن یکسان نیست.', 'danger');
      await captchaRef?.current?.onMakeCaptcha();
      return;
    }
    setIsSubmiting(true);

    try {
      const body = {
        ...data,
        captchaId,
      };
      delete body?.newPassword2;
      await ChangePasswordServices.changePassword(body);

      createToast('موفق', 'رمز عبور با موفقیت تغییر یافت.', 'success');

      setIsSubmiting(false);

      reset();
      await captchaRef?.current?.onMakeCaptcha();

      signOut();
    } catch (error) {
      setIsSubmiting(false);
      await captchaRef?.current?.onMakeCaptcha();
      console.log(error);
    }
  };

  // -- OTHER FUNCTIONS --//
  const signOut = async () => {
    try {
      const res = await AuthService.logout();
      setUser(false);
      window.location.href = res.result;
      // window.location.href = './sign-in';
    } catch (error) {
      setTimeout(() => {
        AuthService.clearToken();
      }, 10);
      window.location.href = './sign-in';
    }
  };

  // -- LOCAL VARIABLES --//
  const hint = 'در این قسمت با تکمیل فرم زیر می توانید رمز عبور خود را تغییر دهید';

  return (
    <div>
      <Typography className={classes.hint}>{hint}</Typography>
      {isLoading ? (
        <LoadingPage />
      ) : (
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(changePass)} noValidate autoComplete="off">
            <Grid container spacing={1}>
              <Grid item xs={12} md={4} lg={3}>
                <InputV2
                  errors={methods.formState.errors}
                  name="oldPassword"
                  dir="ltr"
                  label="رمز عبور فعلی"
                  register={methods.register}
                  type="password"
                  rules={['required']}
                  fullWidth
                  control={methods.control}
                />
              </Grid>
            </Grid>
            <Grid container xs={12} md={8} lg={6} spacing={1}>
              <Grid item xs={12} md={6} lg={6}>
                <InputV2
                  dir="ltr"
                  errors={methods.formState.errors}
                  name="newPassword"
                  type="password"
                  label="رمز عبور جدید"
                  register={methods.register}
                  rules={['required']}
                  fullWidth
                  control={methods.control}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <InputV2
                  dir="ltr"
                  errors={methods.formState.errors}
                  name="newPassword2"
                  type="password"
                  label="تایید رمز عبور جدید"
                  register={methods.register}
                  rules={['required']}
                  fullWidth
                  control={methods.control}
                />
              </Grid>
            </Grid>

            <Grid container wrap="nowrap">
              <InputV2
                errors={methods.formState.errors}
                name="captchaAnswer"
                label="کد امنیتی"
                register={methods.register}
                englishNumber
                forceValue={enteredCaptcha}
                onChangeValue={(e) => {
                  const value = e.target.value;
                  if (value.length > 5) {
                    e.preventDefault();
                    setEnteredCaptcha(value.slice(0, 5));
                  } else {
                    setEnteredCaptcha(value);
                  }
                }}
                rules={['required', 'isNumeric']}
                fullWidth
                dir="ltr"
                control={methods.control}
              />
              <CustomCaptchaComponent
                ref={captchaRef}
                setCaptchaId={setCaptchaId}
                setEnteredCaptcha={setEnteredCaptcha}
                pageTitle="/user-settings?part=change-password - مدیریت کاربری - تب تغییر رمز عبور"
                sizeOptions={{ xs: '12', md: '10', lg: '10' }}

              />
            </Grid>
            <Grid container item xs={12} className={classes.submitContainer} justifyContent="flex-end">
              <ButtonLoading
                type="submit"
                variant="contained"
                color="primary"
                loading={isSubmiting}
                name="تغییر رمز عبور"
              />
            </Grid>
          </form>
        </FormProvider>
      )}
    </div>
  );
};

export default ChangePassword;
